import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import navLogo from '../assets/logo.png';
import '../assets/navbar.css';

const Navbar = () => {
  const location = useLocation();

  const isActive = (pathname) => {
    return pathname === location.pathname;
  };

  return (
    <>
      <nav className="navbar navbar-dark navbar-expand-lg">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={navLogo} alt="Logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/mentorship" className={`nav-link ${isActive('/mentorship') ? 'active' : ''}`}>
                  Mentorship
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/team" className={`nav-link ${isActive('/team') ? 'active' : ''}`}>
                  Team
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/gallery" className={`nav-link ${isActive('/gallery') ? 'active' : ''}`}>
                  Gallery
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
